import SampleVideo from "./GoodSignalStrength.mp4";

export default { SampleVideo };
